var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.458,
    height: 25.986,
    viewBox: "0 0 19.458 25.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task-list-svgrepo-com",
    transform: "translate(-59.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65310",
    "data-name": "Path 65310",
    d: "M75.9,1.18H71.856L71.691.441A.562.562,0,0,0,71.142,0H66.581a.563.563,0,0,0-.549.441l-.164.739H61.819a2.689,2.689,0,0,0-2.686,2.686V23.3a2.689,2.689,0,0,0,2.686,2.686H75.9A2.689,2.689,0,0,0,78.591,23.3V3.867A2.689,2.689,0,0,0,75.9,1.18Zm.931,22.12a.932.932,0,0,1-.931.931H61.819a.932.932,0,0,1-.93-.931V3.867a.932.932,0,0,1,.93-.931h3.659l-.093.42a.562.562,0,0,0,.549.685H71.79a.563.563,0,0,0,.55-.685l-.093-.42H75.9a.932.932,0,0,1,.931.931Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65311",
    "data-name": "Path 65311",
    d: "M157.381,108.338h2.387l-.567-.387a1.755,1.755,0,1,1,1.98-2.9l.093.064v-.67a.787.787,0,0,0-.786-.786h-3.107a.787.787,0,0,0-.786.786v3.106A.787.787,0,0,0,157.381,108.338Z",
    transform: "translate(-92.082 -97.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65312",
    "data-name": "Path 65312",
    d: "M211.209,106.2l-2.752,2.605-1.253-.855a.877.877,0,1,0-.989,1.45l1.837,1.255a.877.877,0,0,0,1.1-.087l3.266-3.092a.878.878,0,1,0-1.207-1.275Z",
    transform: "translate(-138.601 -100.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65313",
    "data-name": "Path 65313",
    d: "M157.381,217.574h2.388l-.568-.388a1.755,1.755,0,0,1,1.98-2.9l.093.064v-.67a.787.787,0,0,0-.786-.786h-3.107a.787.787,0,0,0-.786.786v3.107A.787.787,0,0,0,157.381,217.574Z",
    transform: "translate(-92.082 -201.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65314",
    "data-name": "Path 65314",
    d: "M211.209,215.446l-2.752,2.6L207.2,217.2a.877.877,0,1,0-.989,1.45l1.837,1.255a.877.877,0,0,0,1.1-.087l3.266-3.092a.878.878,0,1,0-1.207-1.275Z",
    transform: "translate(-138.601 -203.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65315",
    "data-name": "Path 65315",
    d: "M160.488,322.135h-3.107a.787.787,0,0,0-.786.786v3.106a.787.787,0,0,0,.786.786h3.107a.787.787,0,0,0,.786-.786v-3.106A.787.787,0,0,0,160.488,322.135Z",
    transform: "translate(-92.082 -304.353)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.114010ad755b56a9a4d9350eb2753119.svg";
export { ForwardRef as ReactComponent };